export function renderBuildFieldErrorHelperSegmentTemplate(): string {
  return `function getFieldErrorMessage(errors: FieldErrors<FormValues>, path: string): string | undefined {
  let current: unknown = errors
  for (const segment of path.split('.')) {
    if (!current || typeof current !== 'object') {
      return undefined
    }
    current = (current as Record<string, unknown>)[segment]
  }
  if (current && typeof current === 'object' && 'message' in current) {
    const message = (current as { message?: unknown }).message
    return typeof message === 'string' ? message : undefined
  }
  return undefined
}`
}
